export const USAGE_PURPOSE_OPTIONS = [
    { value: 1, label: 'Chỉ huy, quản lý' },
    { value: 2, label: 'HL' },
    { value: 3, label: 'VP' },
    { value: 4, label: 'Khác' }
];

export const EQUIPMENT_TYPE_OPTIONS = [
    { value: 1, label: 'Nhóm 1' },
    { value: 2, label: 'Nhóm 2' }
];

export const EQUIPMENT_SOURCE_OPTIONS = [
    { value: 1, label: 'Bệnh viện' },
    { value: 2, label: 'Dự án' },
    { value: 3, label: 'Phòng ATTT' },
    { value: 4, label: 'Nguồn khác' }
];

export const FUNDING_SOURCE_OPTIONS = [
    { value: 1, label: 'Bệnh viện' },
    { value: 2, label: 'Nguồn khác' }
];

export const QUALITY_LEVEL_OPTIONS = [
    { value: 1, label: 'Cấp 1' },
    { value: 2, label: 'Cấp 2' },
    { value: 3, label: 'Cấp 3' },
    { value: 4, label: 'Cấp 4' },
    { value: 5, label: 'Cấp 5' }
];

export const CONNECTION_TYPE_OPTIONS = [
    { value: 1, label: 'Không kết nối' },
    { value: 2, label: 'Mạng chuyên dùng' },
    { value: 3, label: 'Mạng Internet' },
    { value: 4, label: 'Mạng QS' },
    { value: 5, label: 'Mạng riêng' }
];

export const getLabelByValue = (options, value) => {
    const option = options.find(opt => opt.value === value);
    return option ? option.label : '---';
};

